import * as React from 'react';

import { Box, LoadingBox } from '../../../design-system';

const LoadingOrders = () => {
  return (
    <Box display="grid" gridGap="l" mr="xl">
      <LoadingBox height="64px" />
      <LoadingBox height="64px" />
      <LoadingBox height="64px" />
      <LoadingBox height="64px" />
      <LoadingBox height="64px" />
    </Box>
  );
};

export default LoadingOrders;
